module.exports = __webpack_public_path__ + "img/img-18.cb38c2d4.webp";